// extracted by mini-css-extract-plugin
module.exports = {"tablet":"(max-width: 1024px)","mobile":"screen and (max-width: 600px)","container":"container-VYhpR","label":"label-3tGL_","controls":"controls-37-Jf","control":"control-2DWrM"};